const pad = (n, width, z) => {
  const newZ = z || "0";
  const newN = n + "";
  return newN.length >= width
    ? newN
    : new Array(width - newN.length + 1).join(newZ) + newN;
};

export default pad;
